import { render, staticRenderFns } from "./recheduleDelivery.vue?vue&type=template&id=88963066&scoped=true&"
import script from "./recheduleDelivery.vue?vue&type=script&lang=js&"
export * from "./recheduleDelivery.vue?vue&type=script&lang=js&"
import style0 from "./recheduleDelivery.vue?vue&type=style&index=0&id=88963066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88963066",
  null
  
)

export default component.exports